<template>
  <div class="figureBarVertical">
    <canvas :ref="(el) => barChartRef = el"></canvas>
  </div>
</template>

<script setup lang="ts">
  import {ref, onMounted, watch} from "vue";
  import {Chart} from "chart.js";

  
  const props = defineProps<{
    chartData: any;
    unit: string;
    name: string
  }>();
  
  const barChartRef = ref(null);
  const chart = ref(null);
  const options = ref({
    title: {
      display: false,
    },
    legend: {
      display: false,
    },
    scales: {
      xAxes: [{
        display: true,
        stacked: false,
        gridLines: {
          display: false
        },
        ticks: {
          padding: 5,
          fontColor: "rgba(51, 51, 51, 1)",
          fontSize: 10,
          fontFamily: 'oswald, sans-serif',
        },
      }],
      yAxes: [{
        display: true,
        stacked: false,
        gridLines: {
          drawBorder: false,
          color: "rgba(221, 221, 221, 1)",
          zeroLineColor: "rgba(51, 51, 51, 1)"
        },
        ticks: {
          stepSize: 10,
          suggestedMax: 20,
          suggestedMin: 0,
          padding: 20,
          fontColor: "rgba(51, 51, 51, 1)",
          fontSize: 16,
          fontFamily: 'oswald, sans-serif',
        }
      }]
    },
    layout: {
      padding: {
        top: 15
      }
    },
    maintainAspectRatio: false
  })

  onMounted(() => {
    options.value["tooltips"] = {
      mode: 'nearest',
      backgroundColor: "rgba(221, 221, 221, 1)",
      borderColor: "rgba(0, 0, 0, 1)",
      titleFontSize: 17,
      titleFontFamily: 'BIZ UDGothic',
      titleFontStyle: '700',
      titleFontColor: "rgba(51, 51, 51, 1)",
      bodyFontSize: 14,
      bodyFontFamily: 'BIZ UDGothic',
      bodyFontStyle: '700',
      bodyFontColor: "rgba(51, 51, 51, 1)",
      bodySpacing: 10,
      xPadding: 10,
      yPadding: 10,
      callbacks: {
        label: function (tooltipItem, data) {
          let groupName = data.datasets[tooltipItem.datasetIndex].label;
          return `${groupName}：` + tooltipItem.yLabel + `${props.unit}`;
        },
      },
    };
    const ctx = barChartRef.value;
    chart.value = new Chart(ctx, {
        type: "bar",
        data: props.chartData,
        options: options.value
      }
    )
  })

  watch(
    () => props.chartData,
    () => {
      chart.value.data = props.chartData
      chart.value.update()
    }
  )
</script>
